export default __webpack_public_path__ + "static/media/slide-10.6da1cafc.jpeg";